import moment from 'moment'
import { currentYear, graphBarColors } from './StaticData'
import { BLUE_100, PRIMARY_200, WHITE } from '../../../scss/colorConsts'

export const PIQ_TABS = {
  ENCOUNTERS: 'encounters',
  RVU: 'rvu',
  REVENUE: 'Revenue',
}

export const formatter = new Intl.NumberFormat('en-US')
export const revenueFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
})

export function getFormatterByLabel(label) {
  switch (label) {
    case 'Revenue':
      return (money) => parseFloat(money).toFixed(2)

    case 'RVU':
      return (money) => parseFloat(money).toFixed(2)

    case 'Encounters':
      return (money) => money

    default:
      return (money) => money
  }
}

export function getChartData({ tableData, cardInfo }) {
  const lineData = new Array(tableData?.length ?? 0).fill(cardInfo[1].count)

  return {
    labels: tableData
      ?.map((x) => x)
      .sort((a, b) => moment(a.month) - moment(b.month))
      .map((x) => x.month),
    datasets: [
      {
        data: lineData,
        type: 'line',
        borderDash: [6, 6],
        borderDashOffset: 0,
        borderColor: WHITE,
        fill: false,
        borderWidth: 1,
        order: 1,
        scaleID: 'y',

        tooltip: {
          callbacks: {
            title: function () {
              return ''
            },
            label: function (context) {
              let label = ''
              if (context.parsed.x !== null) {
                label = cardInfo[1].count
              }
              return label
            },
          },
        },
      },
      {
        backgroundColor: tableData?.map(() => {
          return BLUE_100
        }),
        data: tableData
          ?.map((x) => x)
          .sort((a, b) => moment(a.month) - moment(b.month))
          .map((x) => x.encounters),
        barPercentage: 0.5,
      },
    ],
  }
}

export function getCardInfo({
  dateWiseEnc,
  monthwiseEnc,
  lastYearEncRes,
  lastYearmonthwiseEncRes,
  cardsData,
  lastYearCardsData,
  prvWeekCount,
  priorWeekCount,
  prvMonthCount,
  priorMonthCount,
  prvWeekDates,
  prevMonthDates,
  priorWeekDates,
  priorMonthDates,
  tableData,
  totalEnc,
  value,
  type,
}) {
  let timePeriod = ''
  let presentData = 0
  let pastData = 0
  let PastTotalEnc = 0
  let presentNoOfDays = 0
  let pastNoOfDays = 0

  let currentyear = monthwiseEnc?.filter(function (e) {
    return e.encounters > 0
  })
  let pastyear = lastYearmonthwiseEncRes?.filter(function (e) {
    return e.encounters > 0
  })
  let newArray = tableData?.filter(function (e) {
    return e.encounters > 0
  })

  if (value === 'Current Year') {
    timePeriod = 'last year'
    presentData = dateWiseEnc?.year
    pastData = lastYearEncRes?.lastYear
    PastTotalEnc = lastYearEncRes?.lastYear
    presentNoOfDays = cardsData?.currentYearLength ? currentyear?.length : 0
    pastNoOfDays = lastYearCardsData?.lastYearLength ? pastyear?.length : 0
  } else if (value === 'Current Week') {
    presentData = dateWiseEnc?.week
    pastData = dateWiseEnc?.lastWeek
    timePeriod = 'last week'
    PastTotalEnc = dateWiseEnc?.lastWeek
    presentNoOfDays = cardsData?.currentWeekLength
      ? Object.values(cardsData?.currentWeekLength)?.filter((x) => x > 0)?.length
      : 0
    pastNoOfDays = cardsData?.preWeekLength
      ? Object.values(cardsData?.preWeekLength)?.filter((x) => x > 0)?.length
      : 0
  } else if (value === 'Last Month') {
    timePeriod = 'prior month'
    if (type !== PIQ_TABS.REVENUE) {
      PastTotalEnc = priorMonthCount
    }
    presentData = prvMonthCount
    pastData = priorMonthCount
    presentNoOfDays = prevMonthDates
      ? Object.values(prevMonthDates)?.filter((x) => x > 0)?.length
      : 0

    pastNoOfDays = priorMonthDates
      ? Object.values(priorMonthDates)?.filter((x) => x > 0)?.length
      : 0
  } else if (value === 'Last Week') {
    timePeriod = 'prior week'
    presentData = dateWiseEnc?.week
    pastData = dateWiseEnc?.lastWeek
    PastTotalEnc = dateWiseEnc?.lastWeek
    if (type === PIQ_TABS.ENCOUNTERS) {
      presentNoOfDays = cardsData?.currentWeekLength
        ? Object.values(cardsData?.currentWeekLength)?.filter((x) => x > 0)?.length
        : 0
      pastNoOfDays = cardsData?.preWeekLength
        ? Object.values(cardsData?.preWeekLength)?.filter((x) => x > 0)?.length
        : 0
    } else if (type === PIQ_TABS.REVENUE) {
      presentData = prvWeekCount
      pastData = priorWeekCount
      PastTotalEnc = priorWeekCount
      presentNoOfDays = cardsData?.currentWeekLength
        ? Object.values(cardsData?.currentWeekLength)?.filter((x) => x > 0)?.length
        : 0
      pastNoOfDays = cardsData?.preWeekLength
        ? Object.values(cardsData?.preWeekLength)?.filter((x) => x > 0)?.length
        : 0
    } else if (type === PIQ_TABS.RVU) {
      presentNoOfDays = prvWeekDates ? Object.values(prvWeekDates)?.filter((x) => x > 0)?.length : 0
      pastNoOfDays = priorWeekDates
        ? Object.values(priorWeekDates)?.filter((x) => x > 0)?.length
        : 0
    }
  } else if (value === 'Last Year') {
    presentData = dateWiseEnc?.year
    pastData = lastYearEncRes?.lastYear
    PastTotalEnc = lastYearEncRes?.lastYear
    presentNoOfDays = cardsData?.currentYearLength ? currentyear?.length : 0
    pastNoOfDays = lastYearCardsData?.lastYearLength ? pastyear?.length : 0

    timePeriod = 'prior year'
  } else if (value === 'Current Month') {
    presentData = dateWiseEnc?.currentMonth
    pastData = dateWiseEnc?.prevMonth
    timePeriod = 'last month'
    PastTotalEnc = dateWiseEnc?.prevMonth
    presentNoOfDays = cardsData?.currentMonthLength
      ? Object?.values(cardsData?.currentMonthLength)?.filter((x) => x > 0)?.length
      : 0
    pastNoOfDays = cardsData?.prevMonthLength
      ? Object.values(cardsData?.prevMonthLength)?.filter((x) => x > 0)?.length
      : 0
  } else {
    timePeriod = 'last year'
    presentData = dateWiseEnc?.year
    pastData = lastYearEncRes?.lastYear
    PastTotalEnc = lastYearEncRes?.lastYear
    presentNoOfDays = newArray?.length ? newArray.length : 0
    pastNoOfDays = lastYearCardsData?.lastYearLength
      ? Object.values(lastYearCardsData?.lastYearLength)?.filter((x) => x > 0)?.length
      : 0
  }

  //Total encounter calculation
  let difference = presentData - pastData
  const TotalEncounterPercentage = Math.abs(difference / pastData) * 100
  const PresentAverageEncPerDay = (totalEnc / presentNoOfDays).toFixed(2)
  const PastAveragePerEncDay = (PastTotalEnc / pastNoOfDays).toFixed(2)
  const AveragePerEncDiff = PresentAverageEncPerDay - PastAveragePerEncDay

  const AveragePerEncDayPercentage = Math.abs(AveragePerEncDiff / PastAveragePerEncDay) * 100

  const pastDataCount = parseFloat(PastAveragePerEncDay)
  const oldData = type === PIQ_TABS.ENCOUNTERS ? pastData : parseFloat(pastData)
  const text2Calc = isNaN(oldData) ? 0 : oldData.toFixed(2)
  const cardInfo = [
    {
      count: getFormatterByLabel(type)(totalEnc),
      percentage: `${Math.round(
        isNaN(TotalEncounterPercentage) ? 0 : TotalEncounterPercentage.toFixed(2),
      )}`,
      text1: 'Total ' + type,
      text2: !Number.isFinite(oldData)
        ? 'N/A'
        : `${type === PIQ_TABS.ENCOUNTERS ? Math.round(text2Calc) : text2Calc} ${timePeriod}`,
      color: PRIMARY_200,
      status: `${difference > 0 ? '+' : '-'}`,
    },
    {
      count: isNaN(PresentAverageEncPerDay)
        ? 0
        : Number.isInteger(Number(PresentAverageEncPerDay))
          ? Math.round(PresentAverageEncPerDay)
          : PresentAverageEncPerDay,
      percentage: `${Math.round(
        isNaN(AveragePerEncDayPercentage) ? 0 : AveragePerEncDayPercentage.toFixed(2),
      )}`,
      text1: `Average ${type}/${
        value === 'Current Year' || value === 'Last Year' ? 'month' : 'day'
      }`,
      text2: !Number.isFinite(TotalEncounterPercentage)
        ? 'N/A'
        : `${isNaN(pastDataCount) ? 0 : pastDataCount.toFixed(2)} ${timePeriod}`,
      color: PRIMARY_200,
      status: `${AveragePerEncDiff > 0 ? '+' : '-'}`,
    },
  ]

  return {
    cardInfo,
  }
}

export function getGraphInfo({ tableData, selDate, graphData, cardInfo, type }) {
  const lineData = new Array(tableData?.length ?? 0).fill(cardInfo[1].count)

  return {
    labels: tableData
      .map((x) => x)
      .sort((a, b) => moment(a.month) - moment(b.month))
      .map((x) => {
        if (selDate === 'previousyear' || selDate === currentYear) {
          return moment(x.month).format('YYYY MMMM')
        } else if (selDate === 'custom' && x.month.length === 7) {
          return moment(x.month, 'MMMM-YYYY').format('YYYY MMMM')
        } else return moment(x.month).format('MM-DD-YYYY')
      }),
    datasets: [
      ...graphData.map((x, indx) => {
        if (x) {
          return {
            ...x,
            backgroundColor: graphBarColors[indx],
            borderColor: graphBarColors[indx],
            barPercentage: 0.5,
            ...(type === PIQ_TABS.ENCOUNTERS && { order: 1 }),
            data: tableData.map((y) => {
              const data = x.data.find((z) => {
                if (
                  selDate === 'previousyear' &&
                  moment(z.month).format('YYYY MMMM') === moment(y.month).format('YYYY MMMM')
                ) {
                  return z
                }
                if (
                  z.month.length === 10 &&
                  y.month.length === 7 &&
                  moment(z.month, 'MM-DD-YYYY').format('MM-YYYY') ===
                    moment(y.month).format('MM-YYYY') &&
                  selDate !== 'previousyear'
                ) {
                  return z
                } else if (
                  moment(z.month).format('MM-DD-YYYY') === moment(y.month).format('MM-DD-YYYY') &&
                  selDate !== 'previousyear'
                ) {
                  return z
                }
              })
              let das = 0
              if (typeof data !== 'undefined') {
                return (das = data.encounters)
              }
            }),
          }
        }
      }),
      {
        data: lineData,
        type: 'line',
        borderDash: [6, 6],
        borderDashOffset: 0,
        borderColor: WHITE,
        ...(type !== PIQ_TABS.ENCOUNTERS && { fill: false }),
        borderWidth: 1,
        order: 1,
        scaleID: 'y',
        tooltip: {
          callbacks: {
            title: function () {
              return ''
            },
            label: function (context) {
              let label = ''
              if (context.parsed.x !== null) {
                label = cardInfo[1].count
              }
              return label
            },
          },
        },
      },
    ],
  }
}
